<template>
   <SignUpDetail />
</template>

<script>
import SignUpDetail from "@/esf_antarctica_lederhosenland/core/components/authentication/sign-up/SignUpDetail.vue"
export default {
  name: "Contact",
  components: {
  SignUpDetail
  },
  
};
</script>